import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import ContentItemLocationsGrid from 'js/components/content-item/ContentItem.locations-grid';
import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

// import actions
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';

// import sections
import HeaderRegionLocations from 'js/containers/header-region/HeaderRegion.locations';

const PageLocations = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.explore_porthole]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.explore_porthole);
  });

  useEffect(() => {
    trackPageview({ title: PAGE_IDS.explore_porthole, path: props.path });
  }, []);

  const { header = {}, promo = null, characters = null } = pageData;
  const { title = '', description = '' } = header;

  return (
    <>
      <SiteMetaData {...meta} />
      <HeaderRegionLocations title={title} description={description} />
      <div className="locations-page__content-grid">
        <SvgTextureLineLong color={'#f7f1c3'} />
        <div className="container">
          <ContentItemLocationsGrid />
        </div>
      </div>
    </>
  );
};

export default PageLocations;
